import { DeviceHeartRateData } from "@/entities/polar";
import firebase from "firebase/app";

export async function getHeartRateDataWithTimeRange({
  from,
  to
}: {
  from: number;
  to: number;
}) {
  const call = firebase
    .app()
    .functions("asia-northeast1")
    .httpsCallable("get_student_heart_rate_data");

  const res = await call({ from, to });

  return res.data.result as DeviceHeartRateData;
}
